import { defineNuxtRouteMiddleware, useNuxtApp } from 'nuxt/app';
import { useCategoryStore } from '~~/common/stores/category';
import { ecomShopPages } from '~~/common/config/EcomPagesConfig';
import { extractResourceFromPath } from '~~/common/utils/urlResource';

export default defineNuxtRouteMiddleware(async (to) => {
  const resource = extractResourceFromPath(to.fullPath);

  if (!((typeof to.name === 'string' && ecomShopPages.includes(to.name)) || resource)) {
    return;
  }
  const { $pinia } = useNuxtApp();

  const categoryStore = useCategoryStore($pinia);
  await categoryStore.fetchCategories();
});
